if (!customElements.get('community-gallery')) {
  class CommunityGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.community-gallery__track');
      this.prevBtn = this.querySelector('[name="prev"]');
      this.nextBtn = this.querySelector('[name="next"]');
      if (!this.track) return;

      this.update = this.update.bind(this);

      this.prevBtn?.addEventListener('click', () => this.scrollByPage(-1));
      this.nextBtn?.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', this.update, { passive: true });
      document.addEventListener('on:debounced-resize', this.update);

      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('on:debounced-resize', this.update);
    }

    scrollByPage(direction) {
      const amount = this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const scrolled = Math.abs(this.track.scrollLeft);
      const scrollable = maxScroll > 2;

      this.classList.toggle('is-scrollable', scrollable);

      if (this.prevBtn) this.prevBtn.disabled = scrolled <= 1;
      if (this.nextBtn) this.nextBtn.disabled = scrolled >= maxScroll - 1;
    }
  }

  customElements.define('community-gallery', CommunityGallery);
}
